import 'picturefill';

// Import scss so webpack will bundle it and export with ExtractTextPlugin
import '../scss/global.scss';

import './features/detectBrowser.js';
import './features/heroBanner.js';
import './features/nav.js';
import './features/smoothScroll.js';
import './features/wallpaperCarousel';
import './features/wallpaperModal';
import './features/teaserVideo';
import './features/displays';
import './AbilitiesPlayer';



// WEBPACK FOOTER //
// ./src/js/main.js